<template>
  <section class="apple-music-video-page">
    <nav class="apple-auxiliary-breadcrumb" aria-label="页面路径"><router-link to="/explore">发现</router-link><span aria-hidden="true">›</span><span>音乐视频</span></nav>
    <div class="apple-music-video-column"><div class="apple-music-video-stage" role="region" aria-label="音乐视频"><span class="apple-music-video-symbol" aria-hidden="true"><svg-icon icon-class="play" /></span><strong>音乐视频暂不可用</strong><p>此来源未提供 MV 播放接口。</p></div><div class="apple-music-video-heading"><h1>音乐视频</h1><AppleButton variant="subtle" to="/library">返回音乐库</AppleButton></div><p class="apple-music-video-description">当前音源没有提供可播放的视频地址。</p></div>
  </section>
</template>
<script>
import Mv from '../views/mv.vue';
import AppleButton from './ui/AppleButton.vue';
export default { name: 'AppleMusicVideo', extends: Mv, components: { AppleButton } };
</script>
